export default "__VITE_ASSET__B0cq98Vu__"